import { useState, useEffect } from "react";
import "./orderDetail.css";
import { useGetOrderById } from "@/hooks/useOrders";
import { formatMoney } from "@/lib";
import { resolverPrecioProducto } from "@/lib/precioProducto";

export const OrderDetailModal = ({ order, show, onHide }) => {
  const { mutateAsync: getOrder } = useGetOrderById();
  const [orderData, setOrderData] = useState([]);

  useEffect(() => {
    if (show && order?.pedido_id) {
      getOrder(order.pedido_id)
        .then((resp) => {
          setOrderData(resp);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [show, order?.pedido_id, getOrder]);

  const getPedidoEstado = (item) => {
    // 1. Obtener valores con valores por defecto de 0 si son nulos.
    // Esto simplifica las comparaciones (ej: null vs 0).
    const cantidad = item.pedido_cantidad || 0;
    const entregado = item.productoEntregados || 0;
    const fallas = item.productoFallas || 0;

    // --- Lógica de Estados ---

    // ⭐️ CASO 1: Retiro Parcial
    // (Ej: Cantidad=2, Fallas=1, Entregado=1)
    if (cantidad > 1 && entregado > 0 && fallas > 0) {
      return (
        <span className="etiqueta-estado estado-parcial">Retiro Parcial</span>
      );
    }

    // ⭐️ CASO 2: Retirado (Completamente)
    // (Ej: Cantidad=1, Entregado=1) O (Cantidad > 0 y todo lo demás fue entregado)
    if (cantidad > 0 && entregado === cantidad && fallas === 0) {
      return <span className="etiqueta-estado estado-retirado">Retirado</span>;
    }

    // ⭐️ CASO 3: Por Retirar (Falla Total)
    // (Ej: Cantidad=1, Fallas=1) O (Cantidad > 0 y todas las unidades están falladas)
    if (cantidad > 0 && fallas === cantidad && entregado === 0) {
      return (
        <span className="etiqueta-estado estado-por-retirar">Por retirar</span>
      );
    }

    // ⭐️ CASO 4: Pendiente (El valor por defecto o estado inicial)
    // (Ej: Cantidad=1, Fallas=0, Entregado=0)
    if (cantidad > 0 && fallas === 0 && entregado === 0) {
      return (
        <span className="etiqueta-estado estado-por-retirar">Por retirar</span>
      );
    }

    // Caso de respaldo si la cantidad es 0 o la lógica no cubre un caso.
    return (
      <span className="etiqueta-estado estado-desconocido">Desconocido</span>
    );
  };

  if (show && order)
    return (
      <div className="order-detail-modal-overlay">
        <div className="order-detail-modal-content">
          <button className="order-detail-close-button" onClick={onHide}>
            ×
          </button>

          <h2>Listado de artículos</h2>
          <p>{order.maquina_direccion}</p>
          <p>Pedido Nro. {order.pedido_id}</p>
          {order.pedido_estado == "Despacho incompleto" ? (
            <div className="order-detail-alert-box">
              <span className="order-detail-alert-icon">⚠️</span>
              <div>
                <strong>Retiros incompletos</strong>
                <p>
                  Escríbenos a nuestro{" "}
                  <a
                    href="https://wa.me/1234567890"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    whatsapp
                  </a>{" "}
                  para ayudarte.
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="order-detail-items-list">
            {orderData.map((item, index) => {
              const { precioFinal, precioOriginal, tieneDescuento } =
                resolverPrecioProducto(item);
              return (
                <div key={index} className="order-detail-item-card">
                  <img
                    src={item.producto_foto}
                    alt={item.producto_nombre}
                    className="order-detail-item-img"
                  />
                  <div className="order-detail-item-details">
                    <h3>{item.producto_nombre}</h3>
                    <p>Artículos: {item.pedido_cantidad}</p>
                    {getPedidoEstado(item)}
                    <div className="order-detail-price">
                      {tieneDescuento && (
                        <span className="order-detail-old-price">
                          {formatMoney(precioOriginal)}
                        </span>
                      )}
                      <span className="order-detail-new-price">
                        {formatMoney(precioFinal)}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
};
